import { SerializedDeviceAttributeCondition } from 'cio/types/conditions/condition';
import { createAttribute } from './attribute';

export function createDeviceAttribute(name: string, operator: string, inverse: boolean, value: string, value2: string) {
  return createAttribute(name, operator, undefined, value, value2, inverse, null, 'device_attribute', null, null);
}

export default function (json: SerializedDeviceAttributeCondition) {
  let { event } = json;
  let name = event?.name;
  let filter = event?.filters?.and?.[0];
  let { operator, inverse, value, value2 } = filter || {};

  return createDeviceAttribute(
    name as string,
    operator as string,
    inverse as boolean,
    value as string,
    value2 as string,
  );
}
